<template>
  <div
    class="toptitle"
    :class="[header.boardstyle,{'scroll-down-hidden': $store.state.scrollMethod === 'down'}]" 
    custom_class="headerTitleAllThemeBtnClass"
    v-if="
      (header.board_image && header.boardstyle == 'image') || 
      (header.boardstyle == 'text' && header.board_title)
    "
  >
    <a class="page_text_font" :href="topTitleURL">
      <div v-if="header.boardstyle == 'text'" class="page_text_font" style="line-height:1.35;">
        {{header.board_title}}
      </div>
      <div v-else >
        <img class="d-md-block d-none" :src="header.board_image" style="display:inline-block;width:100%;" alt="">
        <img class="d-md-none d-block" :src="header.board_mobile_image?header.board_mobile_image:header.board_image" style="display:inline-block;width:100%;" alt="">
      </div>
    </a>
    <!-- <span class="page_text_font" v-else>{{header.board_title}}</span> -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {},
  methods: {
    stickiness(el) {
      let max_top = 0;
      let sectionHeader = $(el);
      if(!sectionHeader.length) return;
      $(window).scroll(function () {
        let top = sectionHeader[0].getBoundingClientRect().top;
        max_top = top > max_top ? top : max_top;
        if ($(window).scrollTop() > max_top + 1) {
          sectionHeader.css({ 'position': 'fixed', 'top': '0', 'z-index': 99, "width": "100%" })
        } else {
          sectionHeader.css({ 'position': 'relative' })
        }
      })
    }
  },
  mounted() {
    let notice_visibility = this.header.notice_visibility
    if (notice_visibility) {
      // this.stickiness('.toptitle')
      document.querySelector("#header").style.cssText += 'position: sticky;top: 0; z-index: 99; width: 100%';
    } 
  },
  computed: {
    ...mapState({
      header: ({ options }) => options.theme?.modules?.header || {}
    }),
    topTitleURL(){
      return this.header?.title_url||this.header?.url_object?.url
    }
  }
};
</script>
<style scoped lang='scss'>
.toptitle {
  padding: 10px 30px;
  background: #1c1d1d;
  color: white;
  font-size: 16px;
  text-align: center;
  a {
    width: 100%;
    display: block;
    text-decoration: none;
    color: white;
  }
}
</style>